import { makeAutoObservable } from "mobx"
import * as DateUtil from "../util/date.js"

export interface PersonProps {
  id?: number
  firstName?: string
  middleName?: string
  lastName?: string
  gender?: string
  age?: number
}

export class Person {
  id?: number
  firstName: string
  middleName: string
  lastName: string
  gender?: string
  age?: number

  constructor(props: PersonProps = {}) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.firstName = props.firstName || ""
    this.middleName = props.middleName || ""
    this.lastName = props.lastName || ""
    this.gender = props.gender
    this.age = props.age
  }

  reset() {
    this.firstName = ""
    this.middleName = ""
    this.lastName = ""
  }

  get fullName(): string {
    return [this.firstName, this.middleName, this.lastName].filter((n) => n !== "").join(" ")
  }

  get adminFormattedName() {
    return `${this.lastName}, ${this.firstName} ${this.middleName || ""}`
  }
}
